import { useQuery } from '@tanstack/react-query';
import ServerError from '../../errors/ServerError';
import SM from '../../services/ServiceManager';

export const useGetContactGroups = ({
    contactId, isEnabled = true, createThreeB = true, createMortgage = false, staleTime = 2 * 60 * 1000, gcTime = 5 * 60 * 1000,
}) => {
    const result = useQuery({
        queryKey: ['getContactGroups', contactId, createThreeB, createMortgage],
        enabled: !!contactId && isEnabled,
        retry: false,
        staleTime,
        gcTime,

        queryFn: async () => {
            const { data } = await SM.customClientService(
                'getContactGroups',
                [{
                    contactId,
                    createThreeB,
                    createMortgage,
                }],
            ) as any;

            return data;
        },
    });

    return {
        ...result,
        error: result.error ? new ServerError(result.error) : result.error,
    };
};
